import ReactGA from "react-ga4";
import { analytics } from "./firebase";
import { logEvent as firebaseLogEvent } from "firebase/analytics";

// Initialize GA4
export const initAnalytics = () => {
  const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;
  if (measurementId) {
    ReactGA.initialize(measurementId);
  } else {
    console.warn("GA4 Measurement ID not found in environment variables");
  }
};

// Log Page View
export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
};

// Log Custom Event (Dual logging to GA4 and Firebase)
export const logEvent = (category, action, label = null, value = null) => {
  // Log to GA4
  const gaEvent = {
    category,
    action,
    label,
  };

  if (value !== null && typeof value === 'number') {
    gaEvent.value = value;
  }

  ReactGA.event(gaEvent);

  // Log to Firebase
  if (analytics) {
    firebaseLogEvent(analytics, action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }

  if (import.meta.env.DEV) {
    console.log(`[Analytics] ${category} - ${action}`, { label, value });
  }
};

export const TRACKING_EVENTS = {
  // Navegación
  NAV_CLICK: "clic_navegacion",
  CALCULATOR_OPEN: "abrir_calculadora",
  CALCULATOR_PREVIEW_SUBMIT: "enviar_calculadora_previa",
  CALCULATOR_FULL_SUBMIT: "enviar_calculadora_completa",
  CONTACT_CLICK: "clic_contacto",
  PROJECT_VIEW: "ver_proyecto",

  // Botones home
  HOME_CALCULATE_SAVINGS: "home_calcular_ahorros",
  HOME_SUCCESS_STORIES: "home_historias_exito",
  HOME_CALCULATE_REGION: "home_calcular_region",
  HOME_KNOW_COMPANY: "home_conocer_empresa",
};
